export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 5.5a1 1 0 011 1v2.815l4.021-2.193A1 1 0 0122.5 8v8a1 1 0 01-1.479.878L17 14.684V17.5a1 1 0 01-1 1H2.5a1 1 0 01-1-1v-11a1 1 0 011-1H16zm-12.5 11H15v-9H3.5v9zM17 11.593v.813l3.5 1.91V9.683L17 11.593z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};